import { ClassNames, CSSClassBuilder, StyleConfig } from '../../theme';

const isInteractive = CSSClassBuilder.create(ClassNames.isInteractive);

export const SVGStyles = {
	[ClassNames.thumbnailZoomWindow]: {
		stroke: StyleConfig.LABEL.STROKE,
		strokeWidth: 5,
		fill: 'rgba(0,0,0,0.35)',
	},
	[ClassNames.cropWindow]: {
		stroke: StyleConfig.LABEL.STROKE,
		strokeWidth: 5,
		fill: 'rgba(0,0,0,0.0)',
	},
	[ClassNames.isThumbnail]: {
		overflow: 'hidden',
	},
	[ClassNames.svg]: {
		'max-height': '100%',
		'max-width': '100%',
		overflow: 'hidden',
		'text-rendering': 'optimizeLegibility',
		'font-family': StyleConfig.FONT_FAMILY,
		'font-size': StyleConfig.FONT_SIZE,
		'user-drag': 'none',
		'user-select': 'none',
		'-moz-user-select': 'none',
		'-webkit-user-drag': 'none',
		'-webkit-user-select': 'none',
		'-ms-user-select': 'none',
	},

	[ClassNames.image]: {
		'user-drag': 'none',
		'user-select': 'none',
		'-moz-user-select': 'none',
		'-webkit-user-drag': 'none',
		'-webkit-user-select': 'none',
		'-ms-user-select': 'none',
	},
	[ClassNames.isImageLoading]: {
		visibility: 'hidden',
	},
	[ClassNames.main]: {
		height: '100%',
	},
	[ClassNames.container]: {
		height: '100%',
	},
	'c-Draw-crosshair--outerline': {
		stroke: StyleConfig.FONT_COLOR,
	},
	[ClassNames.isSelected + ' .' + ClassNames.line.secondary]: {
		stroke: 'lime',
	},
	[ClassNames.isHighlighted + ' .' + ClassNames.line.secondary]: {
		stroke: 'lime',
	},
	[ClassNames.label.delete]: {
		cursor: 'pointer',
	},
	[ClassNames.label.accept]: {
		cursor: 'pointer',
	},
	[ClassNames.isToolActive]: {
		cursor: 'crosshair',
	},
	[ClassNames.mask]: {
		// Transformer: #F17F29
		// Streetlight: #F9DC5C
		// Wire: #CA054D
		// DownGuy: #D4C1EC
		// SpanGuy: #8AFFC1
		// Pole: #0267C1
		// Riser: #008000
		// Recloser: #F17F29
		// Capacitor: #F17F29
		// Cutout arrestor: #F17F29
		// Regulator: #F17F29
		// Switch: #F17F29
		// Crossarm: #800080
		opacity: 0.5,
		strokeWidth: 4,
		width: '100%',
		height: 'auto',
		'& .pole': { fill: '#0267C1' },
		'& .transformer': { fill: '#F17F29' },
		'& .streetlight': { fill: '#F9DC5C' },
		'& .wire': {
			fill: '#CA054D',
			stroke: '#CA054D',
		},
		'& .downguy': {
			fill: '#D4C1EC',
			stroke: '#D4C1EC',
		},
		'& .spanguy': { fill: '#8AFFC1', stroke: '#8AFFC1' },
		'& .bounding-box': { fill: 'none', stroke: 'black', strokeWidth: 1 },
		'& .riser': { fill: '#008000' },
		'& .recloser': { fill: '#F17F29' },
		'& .capacitor': { fill: '#F17F29' },
		'& .cutout-arrestor': { fill: '#F17F29' },
		'& .regulator': { fill: '#F17F29' },
		'& .switch': { fill: '#F17F29' },
		'& .crossarm': { fill: '#800080' },
	},
};

// Dont allow creation of new markers on top of labels
CSSClassBuilder.addStyle(SVGStyles, isInteractive.and(ClassNames.isToolActive).child(ClassNames.label.container), {
	cursor: 'not-allowed',
});

// Show grab cursor on move
CSSClassBuilder.addStyle(SVGStyles, isInteractive.child(ClassNames.label.container), { cursor: 'grab' });
CSSClassBuilder.addStyle(SVGStyles, isInteractive.child(ClassNames.isMoveable), { cursor: 'grab' });
//CSSClassBuilder.addStyle(SVGStyles, isInteractive.child(ClassNames.cropWindow), { cursor: 'grab' });

CSSClassBuilder.addStyle(SVGStyles, isInteractive.and(ClassNames.isMoving), { cursor: 'grabbing' });
CSSClassBuilder.addStyle(SVGStyles, isInteractive.and(ClassNames.isMoving).child(ClassNames.label.container), {
	cursor: 'grabbing',
});
CSSClassBuilder.addStyle(SVGStyles, isInteractive.and(ClassNames.isMoving).child(ClassNames.isMoveable), {
	cursor: 'grabbing',
});

// Linking cursor
CSSClassBuilder.addStyle(SVGStyles, isInteractive.and(ClassNames.isLinking).child(ClassNames.label.container), {
	cursor: 'alias',
});

CSSClassBuilder.addStyle(SVGStyles, isInteractive.and(ClassNames.isToolActive), { cursor: 'crosshair' });
CSSClassBuilder.addStyle(SVGStyles, isInteractive.and(ClassNames.isToolActive).child(ClassNames.isMoveable), {
	cursor: 'crosshair',
});
